<mat-card>
  <mat-card-header class="border-bottom">
    <mat-card-title>
      Adicionar centro de resultado
    </mat-card-title>
  </mat-card-header>
  <div class="row m-0 pt-2">
    <div class="mt-2 col-md-12">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input matInput type="text" [formControl]="form.get('descricao')" />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('required')
        "
      >
        A descrição é obrigatória
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('maxlength')
        "
      >
        A descrição deve conter até 255 caracteres
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('isEmptyValue')
        "
      >
        Inválido: remova os espaços em branco!
      </small>
    </div>
    <div class="mt-2 col-md-12">
      <fast-autocomplete
        #input
        [autoFirst]="false"
        id="field-centro-resultado"
        placeholder="Centro de resultados"
        displayField="descricao"
        [value_order]="'descricao'"
        [domain_id]="tokenService.getDomain().id"
        (clearSelection)="form.get('centro_resultado').reset()"
        [pageValue]="'0'"
        [pageSizeValue]="'20'"
        [control]="form.get('centro_resultado')"
        [entityService]="entityService"
        [actionState]="false"
        [initDataWithEmpty]="true"
        [messages]="{
          typeIs: 'Valor inválido',
          isEmptyValue: 'Valor inválido: remova os espaços em branco'
        }"
      ></fast-autocomplete>
    </div>
  </div>
  <mat-card-actions>
    <div
      class="d-flex justify-content-between align-items-center w-100 flex-wrap mt-2 col-md-12"
    >
      <div
        class="d-flex justify-content-between justify-content-md-start align-items-center mt-2"
        style="flex: 1;"
      >
        <button
          type="button"
          class="mr-md-2"
          mat-stroked-button
          id="cancel-btn"
          [matDialogClose]="undefined"
          [disabled]="loading"
        >
          Cancelar
        </button>
        <button
          id="save-btn"
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="!form.valid || loading"
        >
          Salvar
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
